import { useTranslation } from 'react-i18next';
import { useIsSupportSession } from '../support-access/use-support-session';
import DeleteCompanyForm from '../delete-company-form/delete-company-form';

/* eslint-disable-next-line */
export interface DeleteCompanySettingsProps {}

export function DeleteCompanySettings(props: DeleteCompanySettingsProps) {
  const { t } = useTranslation(['common']);
  const isSupportSession = useIsSupportSession();
  return (
    <div>
      <div className="mt-2">
        <h2 className="text-base font-semibold leading-7 text-light-primaryText dark:text-dark-primaryText">
          {t('Delete Company')}
        </h2>
        <p className="mt-1 text-sm leading-6 text-light-primaryText dark:text-dark-primaryText">
          {t('delete-company-message')}
        </p>
      </div>

      {isSupportSession ? (
        <p className="mt-6 text-sm text-light-primaryText dark:text-dark-primaryText">
          {t('not-available-in-support-session')}
        </p>
      ) : (
        <DeleteCompanyForm />
      )}
    </div>
  );
}

export default DeleteCompanySettings;
